import { lazy } from 'react'

const TurnoGestionApp = lazy(() => import('./view/TurnoGestion'))
export const turnosRoutesMap = {
  gestion: {
    path: '/turnos/gestion',
    name: 'Gestión de Turnos',
  },
}

const turnosRoutes = [
  {
    path: turnosRoutesMap.gestion.path,
    name: turnosRoutesMap.gestion.name,
    element: <TurnoGestionApp />,
  },
]
export default turnosRoutes
